var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"preview-icon"},[_c('a-tooltip',{attrs:{"placement":"top","title":_vm.previewDef[_vm.match].tip}},[_c('a-avatar',{attrs:{"src":_vm.previewUrl,"size":"large"},on:{"click":_vm.download}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }